import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import usePageContent from "@/hooks/usePageContent";
import ScrollReveal from "@/components/ScrollReveal";
import StaggerContainer from "@/components/StaggerContainer";
import { Button } from "@/components/ui/button";

const HowItWorks = () => {
  const { t } = useTranslation();
  const { getContent } = usePageContent("home");

  const steps = [
    {
      number: "01",
      title: getContent("howitworks_step1_title", t("howItWorks.step1Title")),
      description: getContent("howitworks_step1_desc", t("howItWorks.step1Desc")),
    },
    {
      number: "02",
      title: getContent("howitworks_step2_title", t("howItWorks.step2Title")),
      description: getContent("howitworks_step2_desc", t("howItWorks.step2Desc")),
    },
    {
      number: "03",
      title: getContent("howitworks_step3_title", t("howItWorks.step3Title")),
      description: getContent("howitworks_step3_desc", t("howItWorks.step3Desc")),
    },
  ];

  return (
    <section className="section-padding bg-secondary">
      <div className="container-wide">
        {/* Section Header */}
        <ScrollReveal className="text-center mb-16">
          <h2 className="heading-section mb-4 text-primary">
            {getContent("howitworks_title", t("howItWorks.title"))}
          </h2>
          <p className="text-editorial max-w-xl mx-auto">
            {getContent("howitworks_subtitle", t("howItWorks.subtitle"))}
          </p>
        </ScrollReveal>

        {/* Steps */}
        <StaggerContainer className="grid md:grid-cols-3 gap-12 md:gap-8" staggerDelay={0.15}>
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Connector line for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-px bg-border" />
              )}
              
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 mb-6 bg-primary text-primary-foreground rounded-full font-display text-lg">
                  {step.number}
                </div>
                <h3 className="heading-card mb-3 text-primary">{step.title}</h3>
                <p className="text-editorial max-w-xs mx-auto">{step.description}</p>
              </div>
            </div>
          ))}
        </StaggerContainer>

        {/* CTA Button */}
        <ScrollReveal className="text-center mt-12 md:mt-16">
          <Button asChild variant="sectionCta">
            <Link to="/talent">{t("howItWorks.cta", "Find Talent")}</Link>
          </Button>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default HowItWorks;
